import de from './de.json'
import en from './en.json'
import fr from './fr.json'
import it from './it.json'
import es from './es.json'
import pt from './pt.json'
import nl from './nl.json'

export default { de, en, es, fr, it, pt, nl }
